export default __webpack_public_path__ + "static/media/logo_thelostkite.fe926702.png";